import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { ORDER_BASE_PATH } from '../../../../../features/order/order-routing';

export const Route = createFileRoute('/_app/_clearing-core/order/equity/_single')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'equity-orders-list',
        label: 'Orders',
        to: ORDER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
